import { useApesStorageApi } from "@/api/useApesStorageApi";
import { ModalName } from "@/components/Modal/modal-name";
import { useConfirmModal } from "@/composables/useConfirmModal";
import { useModal } from "@/composables/useModal";
import { useToast } from "@/composables/useToast";
import { useToastTransaction } from "@/composables/useToast/useToastTransaction";
import { Config } from "@/config";
import { getApeChangeCode } from "@/helpers/ape-constructor/ape-chage-code";
import { captureError } from "@/helpers/captureError";
import { useApeConstructorStore } from "@/store/ape-constructor";
import { useWalletCollectionStore } from "@/store/wallet-collection";
import { useWeb3Store } from "@/store/web3";
import {
  useApeTraitsContract,
  useOrchestratorContract,
  useTraitsConstructorContract,
} from "@/web3/contracts";
const checkApproveContract = async () => {
  try {
    const wallet = useWeb3Store().walletAddress;
    const approveAddress = useTraitsConstructorContract().options.address;
    const isApproved = await useApeTraitsContract()
      .methods.isApprovedForAll(wallet, approveAddress)
      .call();
    if (isApproved) return true;
    const confirmed = await useConfirmModal({
      title: "Contract Needs your approval",
      text: `The contract requires your approval to use your Ape traits tokens.
      <br><br>After you approve the contract, minting ape will continue.`,
    });
    if (!confirmed) return false;
    const approveForAllResponse = await useToastTransaction(
      useApeTraitsContract(true).methods.setApprovalForAll(
        approveAddress,
        true
      ),
      {
        text: "Approving Ape Traits Contract",
        successText: "You have successfully approved the Ape Traits Contract",
      }
    );
    return approveForAllResponse;
  } catch (err) {
    captureError(err);
  }
};

export const equipApe = async (image) => {
  try {
    const apeConstructorStore = useApeConstructorStore();
    const wallet = useWeb3Store().walletAddress;
    const tokenId = apeConstructorStore.ape.id;
    const attributes = apeConstructorStore.ape.attributes;
    const equippedTraits = apeConstructorStore.equippedTraits;

    const traitsAllIn = equippedTraits.filter((trait) => {
      const { name, categoryName } = trait;
      const existed =
        attributes.findIndex(
          (attr) => attr.trait_type.toLowerCase() === categoryName.toLowerCase() && attr.value.toLowerCase() === name.toLowerCase()
        ) > -1;
      if (existed) return false;
      return true;
    });
    const traitsAllOut = apeConstructorStore.defaultTraits.filter((trait) => {
      // exclude gender,body type etc
      if (!trait.id) return false;
      const { trait_type, value } = trait;
      const exists =
        equippedTraits.findIndex(
          (attr) => attr.name.toLowerCase() === value.toLowerCase() && attr.categoryName.toLowerCase() === trait_type.toLowerCase()
        ) > -1;
      return !exists;
    });
    const traitsIn = traitsAllIn.map((trait) => trait.id);
    const traitsOut = traitsAllOut
      .filter((trait) => !trait.is_og)
      .map((item) => item.id);
    const traitsOGOut = traitsAllOut
      .filter((trait) => trait.is_og)
      .map((item) => item.id);
    console.log("out", traitsOut);
    console.log("out og", traitsOGOut);
    console.log("in", traitsIn);
    const changeCode = getApeChangeCode();
    console.log("code", changeCode);
    if (!traitsIn.length && !traitsOGOut.length && !traitsOut.length) {
      useToast().error({ title: "You haven't changed your Ape" });
      return;
    }
    if (!(await checkApproveContract())) return;
    const data = await useApesStorageApi({
      throw: true,
      toast: { error: true },
    }).exec({
      url: "/constructor/equip",
      params: {
        wallet,
        apeId: tokenId,
        traitsIn,
        traitsOut,
        traitsOGOut,
        changeCode,
        network: Config.network.name,
      },
    });

    if (!data) throw new Error("Cound't sign transaction", { cause: data });
    const { signature } = data;
    useModal().open({
      name: ModalName.ApeMintModal,
      props: { image, type: "minting" },
    });
    await useToastTransaction(
      useTraitsConstructorContract(true).methods.equip(
        tokenId,
        traitsIn,
        traitsOut,
        traitsOGOut,
        changeCode,
        signature
      ),
      {
        text: "Equipping Ape",
      }
    );
    useModal().close();
    useModal().open({
      name: ModalName.ApeMintModal,
      props: { image, type: "done" },
    });
    useWalletCollectionStore().fetchApes();

    return true;
  } catch (err) {
    captureError(err);
    useModal().close();
  }
};
